import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/operations-stations-grid')({
  staticData: {
    section: 'Settings',
    breadcrumb: 'Station Operations',
    layout: 'full-height',
  },
  component: () => <Outlet />,
});
